import React from 'react'
import { theme } from 'antd'

export const withAntdToken = (Component: any) => {
    return (props: any) => {
        const { token } = theme.useToken()
        return <Component {...props} token={token} />
    }
}
